import { createContext } from 'react';
import { ICustomerLocalizationGroup } from 'types';

export type TLocalizationSelectedItem = { id: Nullable<string>; name: Nullable<string> };
export type TTypeOfModalWindow = null | 'error';

export interface ILocalizationState {
	needRefetchWordings: boolean;
	loading: boolean;
	selectedGroup: Nullable<TLocalizationSelectedItem>;
	selectedLanguage: Nullable<TLocalizationSelectedItem>;
	groups: ICustomerLocalizationGroup[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const localizationInitialState: ILocalizationState = {
	needRefetchWordings: false,
	loading: true,
	selectedGroup: null,
	selectedLanguage: null,
	groups: [],
	typeOfModalWindow: null,
};

export interface ILocalizationContext extends ILocalizationState {
	refetchWordings(value: boolean): void;
	setGroup(value: Nullable<TLocalizationSelectedItem>): void;
	setLanguage(value: Nullable<TLocalizationSelectedItem>): void;
	saveTranslation({
		groupId,
		itemKey,
		languageId,
		value,
	}: {
		groupId: Nullable<string>;
		itemKey: Nullable<string>;
		languageId: string;
		value: string;
	}): Promise<boolean>;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const LocalizationContext = createContext<ILocalizationContext>({
	refetchWordings: () => undefined,
	setGroup: () => undefined,
	setLanguage: () => undefined,
	saveTranslation: () => Promise.resolve(false),
	changeTypeOfModalWindow: () => undefined,
	...localizationInitialState,
});
